
import { DiaryEntry } from './types';

/**
 * Retrieve diary entries from localStorage
 */
export function getLocalEntries(): DiaryEntry[] {
  const entriesJson = localStorage.getItem('babyDiaryEntries');
  return entriesJson ? JSON.parse(entriesJson) : [];
}

/**
 * Save a diary entry to localStorage
 */
export function saveLocalEntry(entry: DiaryEntry): void {
  const existingEntries = getLocalEntries();
  existingEntries.push(entry);
  localStorage.setItem('babyDiaryEntries', JSON.stringify(existingEntries));
}

/**
 * Update an entry in localStorage
 */
export function updateLocalEntry(updatedEntry: DiaryEntry): void {
  const entries = getLocalEntries();
  const entryIndex = entries.findIndex(entry => entry.id === updatedEntry.id);
  
  if (entryIndex !== -1) {
    // Preserve the userId when updating
    const userId = entries[entryIndex].userId;
    
    // Update the entry, ensuring userId is preserved
    entries[entryIndex] = { 
      ...updatedEntry,
      userId // Ensure userId is always preserved
    };
    
    // Save back to localStorage
    localStorage.setItem('babyDiaryEntries', JSON.stringify(entries));
  }
}

/**
 * Get local entries for a specific user
 */
export function getLocalUserEntries(userId: string): DiaryEntry[] {
  return getLocalEntries().filter(entry => entry.userId === userId);
}

/**
 * Find an entry by ID in localStorage
 */
export function findLocalEntryById(id: string): DiaryEntry | undefined {
  const entries = getLocalEntries();
  return entries.find(entry => entry.id === id);
}

/**
 * Delete an entry from localStorage
 */
export function deleteLocalEntry(id: string): void {
  const entries = getLocalEntries();
  const updatedEntries = entries.filter(entry => entry.id !== id);
  localStorage.setItem('babyDiaryEntries', JSON.stringify(updatedEntries));
}

/**
 * Check if user has reached free entry limit in localStorage
 */
export function hasReachedLocalFreeLimit(userId: string): boolean {
  const localEntries = getLocalEntries();
  const userEntries = localEntries.filter(entry => 
    entry.userId === userId && !entry.isPremium
  );
  return userEntries.length >= 30;
}
